import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const Reset = ({ onClose }) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(""); // To show validation error

  const handleSubmit = (e) => {
    e.preventDefault();

    // Check if passwords match
    if (password !== confirmPassword) {
      setError("Passwords do not match!");
      return;
    }

    setError(""); // Clear any previous errors
    onClose(); // Close the popup on success
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-4 sm:p-6 relative">
        {/* Close Button */}
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800"
          onClick={onClose}
        >
          ✕
        </button>

        <h1 className="text-lg font-bold text-textColor  md:text-xl mb-3">
          Reset Password Required.
        </h1>
        <label className="block text-sm font-medium text-gray-500 mb-3">
          Welcome! Your login is successful. However, for security purposes, we
          require you to set a new password. Please proceed to update your
          password to continue accessing your account securely. Thank you for
          your cooperation.
        </label>

        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            {/* New Password Field */}
            <div className="relative w-full mb-3">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full p-2 md:p-2.5 bg-white border-b-2 border-gray-200 text-gray-800 hover:border-greenBg  focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                placeholder="New Password"
                required
              />
              <button
                type="button"
                className="absolute inset-y-0 right-3 flex items-center text-gray-400"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            {/* Confirm Password Field */}
            <div className="relative w-full ">
              <input
                type={showPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full p-2 md:p-2.5 bg-white border-b-2 border-gray-200 text-gray-800 hover:border-greenBg focus:border-[1px] focus:border-greenBg/50 focus:outline-none focus:shadow-[0px_0px_8px_rgba(0,112,112,0.6)]"
                placeholder="Confirm Password"
                required
              />
              <button
                type="button"
                className="absolute inset-y-0 right-3 flex items-center text-gray-400"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>

          {/* Show error message if passwords don't match */}
          {error && <p className="text-red-500 text-sm">{error}</p>}

          <button
            type="submit"
            className="w-full text-white bg-customOrange hover:bg-customOrangeHover font-medium rounded-lg text-lg px-4 py-3"
          >
            Get Started
          </button>
        </form>
      </div>
    </div>
  );
};

export default Reset;
